export class FileType {
    id!: number;
    src?: string | ArrayBuffer;
    fileName!: string;
    file?: File;
}